import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="community-products"
export default class extends Controller {
  static targets = ["template", "container"];

  connect() {
    console.log("Community Products controller connected");
  }

  add(event) {
    event.preventDefault();

    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime());
    this.containerTarget.insertAdjacentHTML("beforeend", content);
  }

  remove(event) {
    event.preventDefault();

    const item = event.target.closest(".community-product-item");

    // If it's a persisted record, mark it for deletion instead of removing from DOM
    const destroyInput = item.querySelector("input[name*='_destroy']");
    if (destroyInput) {
      destroyInput.value = "1";
      item.style.display = "none";
    } else {
      // If it's a new record, just remove it from the DOM
      item.remove();
    }
  }
}
